import {
	cancelElectronicReceiptsSuccess,
	confirmElectronicReceiptsHeadersError,
	confirmElectronicReceiptsHeadersSuccess,
	consultElectronicReceiptsSuccess,
	getElectronicReceiptsHeadersSuccess,
	validateElectronicReceiptsSuccess
} from 'actions'
import {
	cancelElectronicReceiptsApi,
	confirmElectronicReceiptsHeadersApi,
	consultElectronicReceiptsApi,
	getElectronicReceiptsHeadersApi,
	validateElectronicReceiptsApi
} from 'api/ElectronicReceipts'
import { ElectronicReceiptsActions } from 'constants/ActionsTypesTs'
import {
	ICancelElectronicReceiptsAction,
	IConfirmElectronicReceiptsHeadersAction,
	IConsultElectronicReceiptsAction,
	IGetElectronicReceiptsHeadersAction,
	IValidateElectronicReceiptAction
} from 'models/ElectronicReceipts'
import { all, call, fork, put, takeEvery } from 'redux-saga/effects'

function* getElectronicReceiptsHeadersRequest({
	payload
}: IGetElectronicReceiptsHeadersAction): any {
	try {
		const values: any = yield call(getElectronicReceiptsHeadersApi, payload)
		yield put(getElectronicReceiptsHeadersSuccess(values))
	} catch (error: any) {
		const { Resultado } = error.response.data
		const errorMessage = !Resultado.Resultado ? Resultado.Mens_error : ''
		yield put(confirmElectronicReceiptsHeadersError(errorMessage))
	}
}

function* confirmElectronicReceiptsHeadersRequest({
	payload
}: IConfirmElectronicReceiptsHeadersAction): any {
	try {
		const { values, callBackReturn } = payload
		const resp: any = yield call(confirmElectronicReceiptsHeadersApi, values)
		yield put(confirmElectronicReceiptsHeadersSuccess(resp))

		if (callBackReturn) {
			callBackReturn()
		}
	} catch (error: any) {
		const { Resultado } = error.response.data
		const errorMessage = !Resultado.Resultado ? Resultado.Mens_error : ''
		yield put(
			confirmElectronicReceiptsHeadersError({
				message: errorMessage,
				confirm: true
			})
		)
	}
}

function* validateElectronicReceiptsRequest({
	payload
}: IValidateElectronicReceiptAction): any {
	try {
		const values: any = yield call(validateElectronicReceiptsApi, payload)
		yield put(validateElectronicReceiptsSuccess(values))
	} catch (error: any) {}
}

function* consultElectronicReceiptsRequest({
	payload
}: IConsultElectronicReceiptsAction): any {
	try {
		const values: any = yield call(consultElectronicReceiptsApi, payload)
		yield put(consultElectronicReceiptsSuccess(values))
	} catch (error: any) {}
}

function* cancelElectronicReceiptsRequest({
	payload
}: ICancelElectronicReceiptsAction): any {
	try {
		const values: any = yield call(cancelElectronicReceiptsApi, payload)
		yield put(cancelElectronicReceiptsSuccess(values))
	} catch (error: any) {}
}

export function* getElectronicReceiptsHeadersSaga() {
	yield takeEvery(
		ElectronicReceiptsActions.GET_ELECTRONIC_RECEIPTS_HEADERS,
		getElectronicReceiptsHeadersRequest
	)
}

export function* confirmElectronicReceiptsHeadersSaga() {
	yield takeEvery(
		ElectronicReceiptsActions.CONFIRM_ELECTRONIC_RECEIPTS_HEADERS,
		confirmElectronicReceiptsHeadersRequest
	)
}

export function* validateElectronicReceiptsSaga() {
	yield takeEvery(
		ElectronicReceiptsActions.VALIDATE_ELECTRONIC_RECEIPTS,
		validateElectronicReceiptsRequest
	)
}

export function* consultElectronicReceiptsSaga() {
	yield takeEvery(
		ElectronicReceiptsActions.CONSULT_ELECTRONIC_RECEIPTS,
		consultElectronicReceiptsRequest
	)
}

export function* cancelElectronicReceiptsSaga() {
	yield takeEvery(
		ElectronicReceiptsActions.CANCEL_ELECTRONIC_RECEIPTS,
		cancelElectronicReceiptsRequest
	)
}

export default function* rootSaga() {
	yield all([
		fork(getElectronicReceiptsHeadersSaga),
		fork(confirmElectronicReceiptsHeadersSaga),
		fork(validateElectronicReceiptsSaga),
		fork(consultElectronicReceiptsSaga),
		fork(cancelElectronicReceiptsSaga)
	])
}
